/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Assigned_ToInputs */

const en_ticket_assigned_to = /** @type {(inputs: Ticket_Assigned_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigned to`)
};

const ja_ticket_assigned_to = /** @type {(inputs: Ticket_Assigned_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`担当者`)
};

const fr_ticket_assigned_to = /** @type {(inputs: Ticket_Assigned_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assigné à`)
};

const de_ticket_assigned_to = /** @type {(inputs: Ticket_Assigned_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zugewiesen an`)
};

/**
* | output |
* | --- |
* | "Assigned to" |
*
* @param {Ticket_Assigned_ToInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_assigned_to = /** @type {((inputs?: Ticket_Assigned_ToInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Assigned_ToInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_assigned_to(inputs)
	if (locale === "ja") return ja_ticket_assigned_to(inputs)
	if (locale === "fr") return fr_ticket_assigned_to(inputs)
	return de_ticket_assigned_to(inputs)
});